import { render } from "./Machinery.vue?vue&type=template&id=a06ed750&scoped=true"
import script from "./Machinery.vue?vue&type=script&lang=js"
export * from "./Machinery.vue?vue&type=script&lang=js"

import "./Machinery.vue?vue&type=style&index=0&id=a06ed750&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06ed750"]])

export default __exports__